import { fetchApi } from '@/config/api'
import { Buyer } from '@/types/buyer'

/**
 * Récupère la liste des acheteurs liés au vendeur connecté
 */
export async function getBuyersByVendor(): Promise<Buyer[]> {
  const query = `
    query GetBuyersByVendor {
      acheteurs {
        id_acheteur
        nomSociete
        email
        statut
      }
    }
  `
  
  const result = await fetchApi<{ acheteurs: Array<{ id_acheteur: string, nomSociete: string, email: string, statut: number }> }>(query)
  
  // Mapper les données pour correspondre à l'interface Buyer
  return result.acheteurs.map(acheteur => ({
    id: parseInt(acheteur.id_acheteur),
    id_acheteur: acheteur.id_acheteur,
    nomSociete: acheteur.nomSociete,
    email: acheteur.email,
    statut: acheteur.statut
  }))
}

/**
 * Recherche des acheteurs liés au vendeur (contain serveur sur nom / email).
 */
export async function searchBuyers(term: string): Promise<Buyer[]> {
  const query = `
    query SearchBuyers($term: String!) {
      acheteurs(search: $term) {
        id_acheteur
        nomSociete
        email
        statut
      }
    }
  `

  const result = await fetchApi<{
    acheteurs: Array<{
      id_acheteur: string
      nomSociete: string
      email: string
      statut: number
    }>
  }>(query, { term })

  return (result.acheteurs ?? []).map((acheteur) => ({
    id: parseInt(acheteur.id_acheteur, 10),
    id_acheteur: acheteur.id_acheteur,
    nomSociete: (acheteur.nomSociete ?? '').trim(),
    email: acheteur.email,
    statut: acheteur.statut,
  }))
}
